import StockTransfer from '../components/StockTransfer';

const JWStockTransfer = () => {
  return <StockTransfer type="JW" title="JW Stock Transfer" />;
};

export default JWStockTransfer;
